import { Box, CircularProgress, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { HeaderList } from "../../Components/Header/HeaderList";
import {
  callAPI,
  getLocalValue,
  LoacalVariables,
  Method
} from "../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";
import { useDispatch } from "react-redux";
import ConfirmationPopup from "../../Components/Confirmation/Confirmation";

export const CustomerList: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const { showMessage } = useSnackbar();
  const dispatch = useDispatch();

  // const { edit } = getPermissions(MasterPages.Users, IRoleMain.Masters);
  // const [totalCount, setTotalCount] = useState<any>();

  // const [customers, setCustomers] = useState<any>([]);
  const [selectedId, setSelectedId] = useState<any>(null);
  const [isPopupOpen, setPopupOpen] = useState(false);

  // useEffect(() => {
  //   const fetchCustomer = async () => {

  //     try {
  //       const response: any = await callAPI("customers", Method.GET);
  //       if (response) {
  //         setCustomers(response.data);
  //       }
  //     } catch (error) {
  //       console.error("failed to retrieve data", error);
  //       showMessage("Something went wrong. Please try again.", "error");
  //     } finally {

  //     }
  //   };

  //   fetchCustomer();
  // }, []);

  /**
   *  Edit function
   * @param action
   * @param row
   */
  const handleAction = async (action: string, row: any) => {
    if (action === "Edit") {
      navigate(`/customer/${row?.customerId}`);
    } else if (action === "Delete") {
      setPopupOpen(true);
      setSelectedId(row?.customerId);
    }
  };

  const handleDelete = (response: any) => {
    dispatch(resetDataComponent("customerGrid"));
    showMessage("Customer deleted successfully!", "success");
  };

  const columns: IColumns[] = [
    {
      header: "Full Name",
      fieldName: "fullName",
      tooltip: true
    },

    {
      header: "Email",
      fieldName: "email",
      tooltip: true
    },
    {
      header: "Phone Number",
      fieldName: "phoneNumber",
      tooltip: true
    },

    {
      header: "Addresss",
      fieldName: "address",
      tooltip: true
    },

    {
      header: "Created At",
      fieldName: "createdAt",
      tooltip: true,
      type: "date"
    },

    {
      header: "Actions",
      fieldName: "actions",
      type: "action",
      actions: ["Edit", "Delete"],
      // actions: [edit ? "Edit" : undefined, "Delete"],
      // actionIcons: {
      //   Edit: <WSIcons.Edit color="primary"/>,
      //   Delete: <WSIcons.Delete color="error"/>
      // },
      actionCallback: (action, row) => handleAction(action, row)
    }
  ];

  const handleClick = () => {
    navigate("/customer");
  };

  const source = {
    url: "customers/search",
    filter: [
      // {
      //               field: "FranchiseId",
      //               operator: "eq",
      //               value: getLocalValue(LoacalVariables.FranchiseId)
      //             }
    ],
    sort: [],
    page: 1,
    pageSize: 100000
  };

  return (
    <>
      <HeaderList
        title="All Customer"
        type="card"
        // info={`${totalCount || 0} Total Records`}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <WSDataGrid
            id="customerGrid"
            title="All Customer"
            columns={columns}
            addButton={{ label: "New", color: "secondary" }}
            onAddButtonClick={handleClick}
            headerType="HaderTopCornered"
            source={source}
          />
        </Grid>
      </Grid>
      {selectedId !== null && (
        <ConfirmationPopup
          apiUrl={"customers"}
          id={selectedId}
          confirmMessage="Are you sure you want to delete this customer?"
          open={isPopupOpen}
          onClose={() => setPopupOpen(false)}
          onConfirm={handleDelete}
          permanent
        />
      )}
    </>
  );
});
